document.addEventListener('DOMContentLoaded', function () {
    const track = document.querySelector('.carousel__track');
    const prevButton = document.querySelector('.carousel__control--prev');
    const nextButton = document.querySelector('.carousel__control--next');
    let categoryItems = Array.from(track.children);

    // Variables for carousel state
    let currentSlide = 0;
    const gap = parseInt(getComputedStyle(track).gap) || 0;

    // Calculate card width
    const calculateCardWidth = () => categoryItems[0].offsetWidth + gap;

    // Clone items for infinite scroll
    const setupInfiniteScroll = () => {
        const visibleCards = Math.floor(track.parentElement.offsetWidth / calculateCardWidth());

        // Clone start and end items
        const cloneStart = categoryItems.slice(0, visibleCards).map(item => item.cloneNode(true));
        const cloneEnd = categoryItems.slice(-visibleCards).map(item => item.cloneNode(true));

        // Append clones
        cloneStart.forEach(clone => track.appendChild(clone));
        cloneEnd.reverse().forEach(clone => track.prepend(clone));

        // Update the list of items
        categoryItems = Array.from(track.children);

        // Position carousel to the original items
        const offset = visibleCards * calculateCardWidth();
        track.style.transform = `translateX(-${offset}px)`;
        currentSlide = visibleCards; // Adjust slide to start at the original items
    };

    // Update carousel position
    const updateCarousel = () => {
        const cardWidth = calculateCardWidth();
        const offset = cardWidth * currentSlide;
        track.style.transition = 'transform 0.5s ease-in-out';
        track.style.transform = `translateX(-${offset}px)`;
    };

    // Reset position for infinite scrolling
    const resetCarousel = () => {
        const visibleCards = Math.floor(track.parentElement.offsetWidth / calculateCardWidth());
        const totalCards = categoryItems.length;

        if (currentSlide < visibleCards) {
            currentSlide += totalCards - 2 * visibleCards;
            track.style.transition = 'none';
            const offset = calculateCardWidth() * currentSlide;
            track.style.transform = `translateX(-${offset}px)`;
        } else if (currentSlide >= totalCards - visibleCards) {
            currentSlide -= totalCards - 2 * visibleCards;
            track.style.transition = 'none';
            const offset = calculateCardWidth() * currentSlide;
            track.style.transform = `translateX(-${offset}px)`;
        }
    };

    // Event listeners for arrows
    prevButton.addEventListener('click', () => {
        currentSlide--;
        updateCarousel();
        track.addEventListener('transitionend', resetCarousel, { once: true });
    });

    nextButton.addEventListener('click', () => {
        currentSlide++;
        updateCarousel();
        track.addEventListener('transitionend', resetCarousel, { once: true });
    });

    // Setup infinite scrolling
    setupInfiniteScroll();
});


document.addEventListener('DOMContentLoaded', function () {
    const categoryItems = document.querySelectorAll('[js-category-item]');
    const promoContainers = document.querySelectorAll('.js-promo-container');

    categoryItems.forEach((item, index) => {
        item.addEventListener('click', function () {
            // Remove 'is-active' from all cards
            categoryItems.forEach(card => card.classList.remove('is-active'));

            // Add 'is-active' to the clicked card
            item.classList.add('is-active');

            // Get the target container class from data-target
            const targetClass = item.getAttribute('data-target');

            // Remove 'is-active' from all containers
            promoContainers.forEach(container => container.classList.remove('is-active'));

            // Add 'is-active' to the matching container
            const targetContainer = document.querySelector(`.${targetClass}`);
            if (targetContainer) {
                targetContainer.classList.add('is-active');
            } else {
                console.warn(`No matching promo container found for: .${targetClass}`);
            }
        });
    });
});

